import api from "@/Library/api.js";

export default {

    //测试访问接口
    TEST_INDEX(data) {
        return api({ url: "/Test/index", method: "post", act: "pro_xlsout", data: data });
    },

    //上传图片信息
    UPLOAD_FILES(data) {
        return api({ url: "/Upload/index", method: "post", act: "avar", data: data });
    }

}